import { z } from 'zod';

export const applicationSchema = z.object({
  name: z.string().min(1, 'validation.required'),
});

export const moduleSchema = z.object({
  code: z.string().min(1, 'validation.required'),
  name: z.string().min(1, 'validation.required'),
});
